import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageSurfaceHeaderComponent } from './components/page-surface-header/page-surface-header.component';
import { RouterModule } from '@angular/router';
import { CardOuterComponent } from './components/card-outer/card-outer.component';
import { CardTitleComponent } from './components/card-title/card-title.component';
import { BirthdayCardComponent } from './components/birthday-card/birthday-card.component';
import { CardContentComponent } from './components/card-content/card-content.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IconModule } from "./components/icon/icon.module";
import { MaterialModule } from '../material.module';


@NgModule({
  imports: [
    CommonModule,
    PageSurfaceHeaderComponent,
    CardOuterComponent,
    CardTitleComponent,
    BirthdayCardComponent,
    CardContentComponent,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    IconModule,
    MaterialModule,
],
  exports: [
    PageSurfaceHeaderComponent,
    CardOuterComponent,
    CardTitleComponent,
    BirthdayCardComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }
